<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1100px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('View Statement Payable Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">
                {{ $t('Statement Payable') }}
              </th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Salesman') }}</div>
                      <strong>{{ viewInfo.sale_man_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Code') }}</div>
                      <strong>{{ viewInfo.payable_statement_auto_number || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Date') }}</div>
                      <strong>{{ viewInfo.statement_date }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Amount')} (${systemCurrency})` }}
                      </div>
                      <strong v-if="viewInfo.amount">
                        {{ viewInfo.amount | currency }}
                      </strong>
                      <strong v-else>-</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Balance')} (${systemCurrency})` }}
                      </div>
                      <strong v-if="viewInfo.balance">
                        {{ viewInfo.balance | currency }}
                      </strong>
                      <strong v-else>-</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Paid')} (${systemCurrency})` }}
                      </div>
                      <strong v-if="viewInfo.paid">{{ viewInfo.paid | currency }}</strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Net Cost')} (${systemCurrency})` }}
                      </div>
                      <strong>{{ net_cost | currency }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ `${$t('Net Amount')} (${systemCurrency})` }}
                      </div>
                      <strong>{{ net_amount | currency }}</strong>
                    </td>
                  </tr>
                </table>
              </v-layout>

              <v-layout row wrap justify-center mt-4 mb-3 v-if="saleRowNumbers > 0">
                <table>
                  <tr>
                    <th class="section-title-content">
                      {{ $t('Sale Details') }}
                    </th>
                  </tr>
                </table>

                <v-flex xs10>
                  <v-divider />
                </v-flex>
              </v-layout>

              <v-layout row wrap class="invoice-content" v-if="saleRowNumbers > 0">
                <v-flex xs12 sm12>
                  <v-layout row wrap>
                    <table class="printed-table" cellspacing="0">
                      <thead>
                        <tr class="only-for-print">
                          <td>
                            <div class="header-space">&nbsp;</div>
                          </td>
                        </tr>
                        <tr>
                          <th xs1 class="pa-2 view-table-header">#</th>
                          <th class="view-table-header" xs3 pa-2>
                            {{ $t('Customer Name') }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ $t('Invoice No.') }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ $t('Date') }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ `${$t('Sold Product Cost')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ `${$t('Total Amount')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header not-printable" xs2 pa-2>
                            {{ $t('Detail') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in saleRowNumbers" :key="index">
                          <td class="view-table-row">
                            <p class="view-table-content">{{ index + 1 }}</p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleDetail.customer_name[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleDetail.bill_auto_number[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleDetail.bill_date[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleDetail.sold_product_cost_sale[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleDetail.total_amount_sale[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p
                              style="cursor: pointer"
                              class="view-table-content not-printable"
                              flat
                              small
                              @click="viewSale(saleDetail.sale_id[index])"
                            >
                              View
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" colspan="5">
                            <p class="view-table-content">
                              {{ `${$t('Total Amount')} (${systemCurrency})` }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ saleDetail.total_amount | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" colspan="5">
                            <p class="view-table-content">
                              {{ $t('Sold Product Cost') }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ saleDetail.sold_product_cost | currency }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="only-for-print">
                          <td>
                            <div class="footer-space">&nbsp;</div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout row wrap justify-center mt-5 mb-3 v-if="saleReturnRowNumbers > 0">
                <table>
                  <tr>
                    <th class="section-title-content">
                      {{ $t('Sale Return Details') }}
                    </th>
                  </tr>
                </table>

                <v-flex xs10>
                  <v-divider />
                </v-flex>
              </v-layout>

              <v-layout row wrap class="invoice-content" v-if="saleReturnRowNumbers > 0">
                <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
                  <v-layout row wrap>
                    <table class="printed-table" cellspacing="0">
                      <thead>
                        <tr class="only-for-print">
                          <td>
                            <div class="header-space">&nbsp;</div>
                          </td>
                        </tr>
                        <tr>
                          <th xs1 class="pa-2 view-table-header">#</th>
                          <th class="view-table-header" xs3 pa-2>
                            {{ $t('Customer Name') }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ $t('Return Invoice No.') }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ $t('Return Date') }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ `${$t('Return Product Cost')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header" xs2 pa-2>
                            {{ `${$t('Return Total Amount')} (${systemCurrency})` }}
                          </th>
                          <th class="view-table-header not-printable" xs2 pa-2>
                            {{ $t('Detail') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in saleReturnRowNumbers" :key="index">
                          <td class="view-table-row">
                            <p class="view-table-content">{{ index + 1 }}</p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleReturnDetail.customer_name[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleReturnDetail.return_sale_number[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleReturnDetail.return_date[index] }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleReturnDetail.return_product_cost_sale[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ saleReturnDetail.return_total_amount_sale[index] | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p
                              style="cursor: pointer"
                              class="view-table-content not-printable"
                              flat
                              small
                              @click="viewSaleReturn(saleReturnDetail.sale_return_id[index])"
                            >
                              View
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" colspan="5">
                            <p class="view-table-content">
                              {{ `${$t('Return Total Amount')} (${systemCurrency})` }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ saleReturnDetail.return_total_amount | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr class="last-table-row-for-currency">
                          <td class="last-table-row" colspan="5">
                            <p class="view-table-content">
                              {{ $t('Return Product Cost') }}
                            </p>
                          </td>
                          <td class="last-table-row2">
                            <p class="view-table-content">
                              {{ saleReturnDetail.return_product_cost | currency }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="only-for-print">
                          <td>
                            <div class="footer-space">&nbsp;</div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </v-layout>
                </v-flex>
              </v-layout>

              <invoice-footer
                :showSignatureSection="true"
                :accountantName="viewInfo.accountant"
                :payerRecipientName="''"
                :payerOrRecipient="''"
                class="only-for-print"
              />
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>

    <sale-view :viewDialog="dialogs.viewSaleDialog" @hidemodal="dialogs.viewSaleDialog = false" />
    <sale-return-view :viewDialog="dialogs.viewSaleReturnDialog" @hidemodal="dialogs.viewSaleReturnDialog = false" />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue'),
    saleView: () => import('@/views/accounting/sales/viewSale.vue'),
    saleReturnView: () => import('@/views/accounting/salesReturns/viewSalesReturn.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      dialogs: {
        viewSaleDialog: false,
        viewSaleReturnDialog: false
      },
      systemCurrency: localStorage.systemCurrency,
      saleRowNumbers: 0,
      saleDetail: {
        total_amount: 0,
        sold_product_cost: 0,
        sale_id: [],
        bill_auto_number: [],
        bill_date: [],
        sold_product_cost_sale: [],
        total_amount_sale: [],
        customer_name: []
      },
      saleReturnRowNumbers: 0,
      saleReturnDetail: {
        return_total_amount: 0,
        return_product_cost: 0,
        sale_return_id: [],
        customer_name: [],
        return_sale_number: [],
        return_date: [],
        return_total_amount_sale: [],
        return_product_cost_sale: []
      },
      net_cost: 0,
      net_amount: 0
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.saleRowNumbers = this.viewInfo.detail.sales.length
          this.saleDetail.total_amount = this.viewInfo.detail.total_amount
          this.saleDetail.sold_product_cost = this.viewInfo.detail.sold_product_cost

          this.saleDetail.sale_id = []
          this.saleDetail.bill_auto_number = []
          this.saleDetail.bill_date = []
          this.saleDetail.sold_product_cost_sale = []
          this.saleDetail.total_amount_sale = []
          this.saleDetail.customer_name = []

          this.viewInfo.detail.sales.forEach(c => {
            this.saleDetail.sale_id.push(c.sale_id)
            this.saleDetail.bill_auto_number.push(c.bill_auto_number)
            this.saleDetail.bill_date.push(c.bill_date)
            this.saleDetail.sold_product_cost_sale.push(c.sold_product_cost)
            this.saleDetail.total_amount_sale.push(c.total_amount)
            this.saleDetail.customer_name.push(c.customer_name)
          })

          this.saleReturnRowNumbers = this.viewInfo.detail.returned_sales.length
          this.saleReturnDetail.return_total_amount = this.viewInfo.detail.return_total_amount
          this.saleReturnDetail.return_product_cost = this.viewInfo.detail.return_product_cost

          this.saleReturnDetail.sale_return_id = []
          this.saleReturnDetail.customer_name = []
          this.saleReturnDetail.return_sale_number = []
          this.saleReturnDetail.return_date = []
          this.saleReturnDetail.return_total_amount_sale = []
          this.saleReturnDetail.return_product_cost_sale = []

          this.viewInfo.detail.returned_sales.forEach(c => {
            this.saleReturnDetail.sale_return_id.push(c.sale_return_id)
            this.saleReturnDetail.customer_name.push(c.customer_name)
            this.saleReturnDetail.return_sale_number.push(c.return_sale_number)
            this.saleReturnDetail.return_date.push(c.return_date)
            this.saleReturnDetail.return_total_amount_sale.push(c.return_total_amount)
            this.saleReturnDetail.return_product_cost_sale.push(c.return_product_cost)
          })

          this.net_cost = this.viewInfo.detail.net_cost
          this.net_amount = this.viewInfo.detail.net_amount
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      viewInfo: 'accountStatements/getStatementInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    ...mapActions({
      fetchSaleReturnInfo: 'salesReturns/fetchSaleReturnInfo',
      fetchSaleInfo: 'sales/fetchSaleInfo'
    }),
    printMe() {
      // we pass true parameter to the function
      // in this way we know that we print invoice and some other style should apply
      // if we don't pass anything it will be false which means
      // we don't print invoice and other styles won't be applied
      // helpers.doPrinting(this.saleRowNumbers > 0)

      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      if (this.saleRowNumbers > 0) {
        document.querySelector('.printed-table').style.marginTop = '-120px'
      }

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        if (this.saleRowNumbers > 0) {
          document.querySelector('.printed-table').style.marginTop = '0px'
        }
      })
    },

    viewSale(id) {
      this.fetchSaleInfo(id)
        .then(() => {
          this.dialogs.viewSaleDialog = true
        })
        .catch(() => {
          /* on error don't show dialog */
        })
    },

    viewSaleReturn(id) {
      this.fetchSaleReturnInfo(id)
        .then(() => {
          this.dialogs.viewSaleReturnDialog = true
        })
        .catch(() => {
          /* on error don't show dialog */
        })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
